<div class="flex-column gap-32">

    <app-card preCardTitle="Cartegraph management" icon="arrow_back" (iconClicked)="navigateBack()">
        <div *appCardContent class="settings-header-container">
            <div class="settings-header-title">
                <p>Manage Cartegraph Resources</p>
                <div class="settings-header-subtitle">
                    Shows imported data used in mobile application and not listed in standard PlowOps listings.
                </div>
            </div>
        </div>
    </app-card>

    <app-card preCardTitle="Materials">
        <div *appCardContent>
            @if (materialResource.isLoading()) {
                <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
            } @else {
                <mat-action-list>
                    @for (material of materialResource.value().data; track material.id) {
                        <button mat-list-item>
                            <mat-icon matListItemIcon>article</mat-icon>
                            <div matListItemTitle>[{{ material.id }}] {{ material.name }}</div>
                        </button>
                        @if (!$last) {
                            <mat-divider></mat-divider>
                        }
                    } @empty {
                        No materials imported or material import is disabled
                    }
                </mat-action-list>
            }
        </div>

    </app-card>

    <app-card preCardTitle="Material Locations">
        <div *appCardContent>
            @if (materialLocationResource.isLoading()) {
                <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
            } @else {
                <mat-action-list class="raw-card-list">
                    @for (location of materialLocationResource.value().data; track location.id) {
                        <button mat-list-item>
                            <mat-icon matListItemIcon>article</mat-icon>
                            <div matListItemTitle>[{{ location.id }}] {{ location.name }}</div>
                        </button>
                        @if (!$last) {
                            <mat-divider></mat-divider>
                        }
                    } @empty {
                        No locations imported or locations import is disabled
                    }
                </mat-action-list>
            }
        </div>
    </app-card>

    <app-card preCardTitle="Vehicle attachments">
        <div *appCardContent>
            @if (vehicleAttachmentResource.isLoading()) {
                <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
            } @else {
                <mat-action-list class="raw-card-list">
                    @for (attachment of vehicleAttachmentResource.value().data; track attachment.id) {
                        <button mat-list-item>
                            <mat-icon matListItemIcon>article</mat-icon>
                            <div matListItemTitle>[{{ attachment.id }}] {{ attachment.name }}</div>
                        </button>
                        @if (!$last) {
                            <mat-divider></mat-divider>
                        }
                    } @empty {
                        No attachments imported
                    }
                </mat-action-list>
            }
        </div>
    </app-card>

</div>